<template>
  <div id="contact">
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <h2 class="section-title">Contact Us</h2>
        </div>
      </div>
      <form>
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="row">
              <div class="col-md-12">
                <p class="alert alert-warning">
                  We take all your queries very seriously. Please let us know your amazing feedback or if you
                  experienced something that you would like to be improved.
                </p>
              </div>
              <div class="col-md-6">
                <div :class="[name ? 'show-label' : '', 'form-group']">
                  <label>Full Name</label>
                  <input type="text" autocomplete="off" class="form-control" placeholder="Full Name" v-model="name"/>
                  <h6 class="text-danger small" v-if="formError">{{ formError.name }}</h6>
                </div>
              </div>
              <div class="col-md-6">
                <div :class="[email ? 'show-label' : '', 'form-group']">
                  <label>Email</label>
                  <input type="text" autocomplete="off" class="form-control" placeholder="Email" v-model="email"/>
                  <h6 class="text-danger small" v-if="formError">{{ formError.email }}</h6>
                </div>
              </div>
              <div class="col-md-12">
                <div :class="[subject ? 'show-label' : '', 'form-group']">
                  <label>Subject</label>
                  <input type="text" autocomplete="off" class="form-control" placeholder="Subject" v-model="subject"/>
                  <h6 class="text-danger small" v-if="formError">{{ formError.subject }}</h6>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <textarea class="form-control" placeholder="Leave a note..." rows="5" v-model="message"></textarea>
                  <h6 class="text-danger small" v-if="formError">{{ formError.message }}</h6>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <b-btn variant="primary" class="pull-left" @click="sendMessage()">Send Message</b-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="card-map">
      <div class="map">
        <div id="map"></div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import { mapState } from 'vuex'
  export default {
    name: 'homepage',
    data () {
      return {
        formError: null,
        email: null,
        name: null,
        subject: null,
        message: null
      }
    },
	  computed: {
		  ...mapState({
			  user: state => state.user,
			  location: state => state.location
		  })
	  },

    methods: {
      sendMessage () {
        let kf = this
        let locationId = kf.location.id

        this.$store.dispatch('LoadingOn')
        this.$store.dispatch('SendMessage', {
        	location: locationId,
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        })
          .then(() => {
            setTimeout(function () {
              kf.notifyVue('success', 'Your message was successfully sent!')
              kf.$store.dispatch('LoadingOff')
              kf.formError = null
              kf.name = null
              kf.email = null
              kf.subject = null
              kf.message = null
            }, 1000)
          })
          .catch(error => {
            this.$store.dispatch('LoadingOff')
            this.formError = {
              'name': error.errors.name ? error.errors.name.join(' ') : null,
              'email': error.errors.email ? error.errors.email.join(' ') : null,
              'subject': error.errors.subject ? error.errors.subject.join(' ') : null,
              'message': error.errors.message ? error.errors.message.join(' ') : null
            }
          })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    mounted () {
      const locationId = this.location.id

      let myLatlng = locationId === 1 ? new window.google.maps.LatLng(51.5181877, -0.0791569) : new window.google.maps.LatLng(51.522148, -0.1130205)
      let mapOptions = {
        zoom: 16,
        center: myLatlng,
        scrollwheel: false, // we disable de scroll over the map, it is a really annoing when you scroll through page
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]

      }
      let map = new window.google.maps.Map(document.getElementById('map'), mapOptions)

      let contentLiverpool = '<div id="content">'+
        '<div id="siteNotice">'+
        '</div>'+
        '<h3 id="firstHeading" class="firstHeading"><strong>Kungfood</strong></h3>'+
        '<div id="bodyContent">'+
        '<p><strong>Liverpool Street</strong></p>'+
        '<p>126A Middlesex St, Whitechapel, London E1 7HY<br>'+
        '020 7247 1088<br>'+
        'info@kungfood.com</p>'+
        '</div>'+
        '</div>';

      let contentClerkenwell = '<div id="content">'+
        '<div id="siteNotice">'+
        '</div>'+
        '<h3 id="firstHeading" class="firstHeading"><strong>Kungfood</strong></h3>'+
        '<div id="bodyContent">'+
        '<p><strong>Clerkenwell</strong></p>'+
        '<p>158 Clerkenwell Rd, London EC1R 5DU<br>'+
        '020 7713 6338<br>'+
        'info@kungfood.com</p>'+
        '</div>'+
        '</div>';

      let infowindow = new google.maps.InfoWindow({
        content: locationId === 1 ? contentLiverpool : contentClerkenwell
      });

      let marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'KungFood ' + locationId === 1 ? 'Liverpool St.' : 'Clerkenwell',
        animation: google.maps.Animation.DROP
      })

      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });

      infowindow.open(map,marker);

      // To add the marker to the map, call setMap();
      marker.setMap(map)
    }
  }

</script>



// WEBPACK FOOTER //
// contact.vue?76744e9e